import { env } from "@beztack/env/ui";

const FALLBACK_LIGHT_STYLE_URL = "https://basemaps.cartocdn.com/gl/positron-gl-style/style.json";
const FALLBACK_DARK_STYLE_URL = "https://basemaps.cartocdn.com/gl/dark-matter-gl-style/style.json";

export const MAPCN_MAP_STYLES = {
  light: env.VITE_MAPCN_TILES_URL || FALLBACK_LIGHT_STYLE_URL,
  dark: env.VITE_MAPCN_TILES_URL || FALLBACK_DARK_STYLE_URL,
};

export const MAPCN_STYLE_URL = MAPCN_MAP_STYLES.light;

export type LngLat = {
  lng: number;
  lat: number;
};

export const DEFAULT_CENTER: LngLat = {
  lng: -56.1645,
  lat: -34.9011,
};

export const DEFAULT_ZOOM = 14;
